import React from 'react';
import secureStorage from '../utils/secureStorage';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('GlobalErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleClearAndReload = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {
      // ignore
    }
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0a0a1a',
          color: '#fff',
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          padding: '20px'
        }}>
          <div style={{ textAlign: 'center', maxWidth: '500px' }}>
            <div style={{ fontSize: '48px', color: '#e97320', fontWeight: 'bold', marginBottom: '8px' }}>
              EXRSIM
            </div>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '32px', letterSpacing: '2px' }}>
              PLAN - EXECUTE - ANALYSE
            </div>
            <h2 style={{ color: '#e97320', marginBottom: '16px', fontSize: '20px' }}>
              Something went wrong
            </h2>
            <p style={{ color: '#aaa', marginBottom: '24px', fontSize: '14px', lineHeight: '1.6' }}>
              An unexpected error occurred. Please try reloading the page.
            </p>
            {this.state.error && (
              <div style={{
                background: '#1a1a2e',
                border: '1px solid #333',
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '24px',
                textAlign: 'left',
                fontSize: '12px',
                color: '#ff6b6b',
                maxHeight: '120px',
                overflow: 'auto'
              }}>
                {this.state.error.toString()}
              </div>
            )}
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={this.handleReload}
                style={{
                  background: '#e97320',
                  color: '#000',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px'
                }}
              >
                Reload Page
              </button>
              <button
                onClick={this.handleClearAndReload}
                style={{
                  background: 'transparent',
                  color: '#e97320',
                  border: '1px solid #e97320',
                  padding: '10px 24px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px'
                }}
              >
                Clear Cache & Reload
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
